export default __webpack_public_path__ + "static/media/icon-Hub-Sharing.115ac19e.svg";